var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.measureTypeData),callback:function ($$v) {_vm.measureTypeData=$$v},expression:"measureTypeData"}},[_c('v-btn',{attrs:{"large":"","value":"distance"}},[_vm._v("\n     Distance\n   ")]),_vm._v(" "),_c('v-btn',{attrs:{"large":"","value":"area"}},[_vm._v("\n     Area\n   ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d2b4819","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/measuretool/MeasureTypeChooser.vue
// module id = Ze2P
// module chunks = 1